import React from 'react';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { StyleSheet } from 'react-native';
import { selectIsGBUser } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
const TierFlatListFooter = () => {
    const isGB = useAppSelector(selectIsGBUser);
    if (!isGB) {
        return null;
    }
    return (<Text TextThin-12 centered Secondary style={styles.footerText}>
      *Open Banking services provided by Emma Technologies LTD under the Payment
      Services Regulations 2017 for the provision of payment services (FCA ref
      number 794952).{'\n\n'}
      Emma is a registered Account Information Service Provider (AISP) and lets
      you see information from all your selected accounts in one place and can
      analyse your spending.
    </Text>);
};
const styles = StyleSheet.create({
    footerText: {
        paddingTop: rem(32),
        padding: rem(16),
    },
});
export default TierFlatListFooter;
